module.exports = __webpack_public_path__ + "images/emoji/rewind.d811c3421b8411d0265d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/rewind.png
// module id = mwkC
// module chunks = 13